module.exports = __webpack_public_path__ + "img/1F1F3-1F1F1.1dda3c3f.svg";